import { render, staticRenderFns } from "./NoticePub.vue?vue&type=template&id=fd50d8aa&scoped=true&"
import script from "./NoticePub.vue?vue&type=script&lang=js&"
export * from "./NoticePub.vue?vue&type=script&lang=js&"
import style0 from "./NoticePub.vue?vue&type=style&index=0&id=fd50d8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd50d8aa",
  null
  
)

export default component.exports